/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { Record } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import UserEvent from '../../event/UserEvent'
import ReservationEvent from '../../event/ReservationEvent'

const ReceptionistSearchState = Record({
  search_date: new Date(),
  search_keywords: '',
  search_hotel_ids: [],
  search_hotel_options: [],
  search_status_checkin: true,
  search_status_checkout: true,
  search_status_staying: true
})

class ReceptionistSearchStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new ReceptionistSearchState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case UserEvent.fetchUserHotels:
        const options = payload.hotels.map(hotel => ({ value: hotel.id, label: hotel.name }))
        return state.merge({
          search_hotel_options: options
        })
      case ReservationEvent.dateChange:
      case ReservationEvent.fetchByDate:
      case ReservationEvent.onReceptionistSearch:
        return state.set('search_date', payload.date)

      case ReservationEvent.receptionistOnEditSearch:
        return state.set(payload.name, payload.value)

      default:
        return state
    }
  }
}

export default new ReceptionistSearchStore()
